module.exports = __webpack_public_path__ + "static/media/Firebg.67eefb8f.png";